<template>
  <div class="fun-facts">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <div class="left-content">
            <h2>Our experience for your <em>business growth</em></h2>
            <p>
              Our company boasts a team of highly experienced professionals, each with over three decades of expertise
              in broadcasting, telecommunications, and ICT. With a focus on strategic growth, technology solutions, and
              business development, our leadership has played pivotal roles in shaping Pakistan's media and telecom
              landscape. Their backgrounds include leadership positions at notable organizations such as Max Media
              Private Limited, Pakistan Television Corporation Limited, and the Ministry of IT and Telecoms. Together,
              they bring unparalleled insight into operational management, project leadership, and industry innovation,
              driving the company forward in an ever-evolving market.
            </p>
            <router-link to="/about" class="filled-button">Read More</router-link>
          </div>
        </div>
        <div class="col-md-6 align-self-center">
          <div class="row">
            <div class="col-md-6">
              <div class="count-area-content">
                <div class="count-digit">945</div>
                <div class="count-title">Work Hours</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="count-area-content">
                <div class="count-digit">1280</div>
                <div class="count-title">Great Reviews</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="count-area-content">
                <div class="count-digit">578</div>
                <div class="count-title">Projects Done</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="count-area-content">
                <div class="count-digit">26</div>
                <div class="count-title">Awards Won</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "FuncFactCard",
};
</script>
<style>
.left-content p {
  text-align: justify;
}
</style>